import { render, staticRenderFns } from "./InfoRestaurante.vue?vue&type=template&id=bdf1bb72&scoped=true"
import script from "./InfoRestaurante.vue?vue&type=script&lang=js"
export * from "./InfoRestaurante.vue?vue&type=script&lang=js"
import style0 from "./InfoRestaurante.vue?vue&type=style&index=0&id=bdf1bb72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf1bb72",
  null
  
)

export default component.exports